import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Button, Image } from 'components/ui';
import localeUtils from 'utils/LanguageLocale';

/**
 * AfterPay Pill Button - Release 4 Style
 * Renders as a pill-shaped button with AfterPay logo
 */
const AfterPayPill = props => {
    const {
        isAfterpayEnabledForThisOrder, isAfterpayEnabledForThisProfile, handlePaymentClick, width, height, imageHeight
    } = props;

    // Don't render if AfterPay is not enabled
    if (!isAfterpayEnabledForThisOrder || !isAfterpayEnabledForThisProfile) {
        return null;
    }

    const isCanada = localeUtils.isCanada();
    const logoSrc = isCanada ? '/img/ufe/logo-afterpay-ca-white.svg' : '/img/ufe/logo-afterpay-white.svg';

    return (
        <Button
            variant='primary'
            onClick={handlePaymentClick}
            data-at={Sephora.debug.dataAt('afterpay_button')}
            aria-label='Pay with AfterPay'
            css={styles}
            height={height || 44}
            minHeight={height || 44}
            width={width || ['151px', '151px', '182px']}
        >
            <Image
                src={logoSrc}
                alt=''
                aria-hidden='true'
                height={imageHeight || '24px'}
            />
        </Button>
    );
};

const styles = {
    backgroundColor: '#000',
    borderRadius: '22px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 24px',
    gap: '12px',
    flexShrink: 0,
    '&:hover': {
        backgroundColor: '#333333'
    }
};

export default wrapFunctionalComponent(AfterPayPill, 'AfterPayPill');
